import { connect } from 'react-redux';
import { RootReducer } from 'store/root-reducer';
import { getRegionId } from 'features/page-model/ducks/get-model';
import { getArticle } from 'common/selectors';
import { getCartItem } from 'features/basket';
import { isWebAvailable as getIsWebAvailable } from 'features/goods-supply';
import { isWebSellable } from 'features/product-info';
import { getModelJson } from 'features/page-model/selectors';
import { PageContent } from './pdp-content';
import { PageContentMappedState } from './types';

export const mapStoreToProps = (store: RootReducer): PageContentMappedState => {
  const pageModel = getModelJson(store);
  const productId = getArticle(store) || '';
  const regionId = getRegionId(store) || '';
  const quantity = getCartItem(productId)(store)?.quantity || 0;
  const isWebAvailable = getIsWebAvailable(store);
  const isSellable = isWebSellable(store);
  const isAvailableForPurchase = isWebAvailable && isSellable;

  return {
    quantity,
    productId,
    regionId,
    seoProductDescription: pageModel?.seoProperties?.metadescription ?? undefined,
    isAvailableForPurchase,
  };
};

export const PageContentConnected = connect(
  mapStoreToProps,
  null,
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...ownProps,
  }),
)(PageContent);
